import { Box, Card, CardContent, Chip, ChipProps, Typography } from "@mui/material";
import React, { ReactNode } from "react";

interface IntegrationCardShellProps {
  title: string;
  description: string;
  statusLabel: string;
  statusColor: ChipProps["color"];
  icon?: ReactNode;
  badges?: ReactNode;
  metadata?: ReactNode;
  actions?: ReactNode;
}

export const IntegrationCardShell: React.FC<IntegrationCardShellProps> = ({
  title,
  description,
  statusLabel,
  statusColor,
  icon,
  badges,
  metadata,
  actions,
}) => {
  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        boxShadow: "none",
        border: "1px solid rgba(224, 224, 224, 1)",
      }}
    >
      <div className="flex justify-between items-center gap-2 p-4 pb-0">
        <div className="flex items-center gap-2">
          {icon}
          <Typography variant="h6">{title}</Typography>
        </div>
        <div className="flex items-center gap-2">
          {badges}
          <Chip label={statusLabel} color={statusColor} size="small" />
        </div>
      </div>

      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
          {description}
        </Typography>
        {metadata && <Box sx={{ mb: 2 }}>{metadata}</Box>}
        {actions && <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>{actions}</Box>}
      </CardContent>
    </Card>
  );
};
